module.exports = __webpack_public_path__ + "static/media/001_BRU.9f98eea7.png";